import * as React from 'react';
import Box from '@mui/material/Box';
//import Avatar from '@mui/material/Avatar';
//import Menu from '@mui/material/Menu';
//import MenuItem from '@mui/material/MenuItem';
//import ListItemIcon from '@mui/material/ListItemIcon';
//import Divider from '@mui/material/Divider';
//import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
//import Tooltip from '@mui/material/Tooltip';
//import PersonAdd from '@mui/icons-material/PersonAdd';
//import Settings from '@mui/icons-material/Settings';
import Logout from '@mui/icons-material/Logout';


export default function AccountMenu() {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <React.Fragment>
      <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
      <a target="_blank" rel="noreferrer" href="https://www.zarkahost.com/"> <Typography sx={{ minWidth: 100 }}>Home</Typography></a>
      <a href="https://www.zarkahost.com/ip-lookup/"> <Typography sx={{ minWidth: 100 }}>Ip Lookup</Typography></a>
      <a href="https://www.zarkahost.com/ip-lookup/about/"> <Typography sx={{ minWidth: 100 }}>About</Typography></a>
      </Box>
    </React.Fragment>
  );
}
